// @ts-strict-ignore
import React, { useMemo } from 'react';

import FormModal from '~/components/FormModal';
import type { InputSection } from '~/components/FormModal/types';
import ReasonForAccessInput from './ReasonForAccessInput';
import ApproverDurationInputs from './ApproverDurationInputs';
import { defaultApproverDuration, defaultReason } from './constants';

interface RequestAccessModalProps {
  approverOptions: Array<{
    label: string;
    value: string;
  }>;
  isOpen: boolean;
  onToggleModal(): void;
  createAccessRequest(formData: any): void;
}

const RequestAccessModal: React.FC<RequestAccessModalProps> = ({
  approverOptions,
  isOpen,
  onToggleModal,
  createAccessRequest,
}) => {
  const inputSections: Array<InputSection> = useMemo(() => ([
    {
      custom: true,
      customKey: 'requested_reason',
      CustomComponent: ReasonForAccessInput,
      customRequiresValidation: true,
      customDefaultValue: defaultReason,
      customValidationFunction: value => (
        typeof value === 'string' && value.length > 0
      ),
      sectionStyle: { width: '50%' },
    },
    {
      custom: true,
      customKey: 'approver_duration',
      CustomComponent: ApproverDurationInputs,
      customProps: { approverOptions },
      customRequiresValidation: true,
      customDefaultValue: defaultApproverDuration,
      customValidationFunction: ({ approver, duration }) => (
        typeof approver === 'string' && typeof duration === 'string'
      ),
      sectionStyle: { width: '100%' },
    },
  ]), [approverOptions]);

  const onSubmit = formData => { createAccessRequest(formData); };

  return (
    <FormModal
      header="Request Access"
      inputSections={inputSections}
      isOpen={isOpen}
      onSubmit={onSubmit}
      onToggleModal={onToggleModal}
      primaryButtonLabel="Request"
      secondaryButtonLabel="Cancel"
    />
  );
};

export default RequestAccessModal;
